import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"
import MasterGamesList from "../data/MasterGamesList"
import { promotionsData } from "../data/PromotionData"
import ModuleFlexiShowDown from "./promotion_modules/modules_flexiSpinShowdown"

export default function FlexiSpinShowdown() {
  const data = promotionsData.find(
    (promo) => promo.title === "Flexi-Spin Showdown"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "Flexi-Spin Showdown": ModuleFlexiShowDown,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const handleFlexiSpinShowdown = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("Flexi-Spin Showdown")
    }
  }
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Flexi-Spin Showdown </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotion</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> Flexi-Spin Showdown </h1>
                <h2> Go Big or Go Many — The choice is yours!</h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span> November 01 (12PM) - November 29 (12PM) , 2025 </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && data.title === "Flexi-Spin Showdown" && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleFlexiSpinShowdown}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <strong> Mechanics: </strong>
                <ol>
                  <li>
                    Play <strong className="highlight">BNG Slots</strong> – all
                    spins count toward the leaderboard.
                  </li>

                  <li>
                    <strong className="highlight">Top 30 players</strong> with
                    the highest turnover will win Flexible FreeBets.
                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "100px" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ background: "#111" }} colSpan={3}>
                              Prizes{" "}
                            </th>
                          </tr>
                          <tr>
                            <th>Rank</th>
                            <th>Number of Winner</th>
                            <th>Flexible FreeBets (PHP)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>1</td>
                            <td>5,000</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>1</td>
                            <td>3,500</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>1</td>
                            <td>2,500</td>
                          </tr>
                          <tr>
                            <td>4-5</td>
                            <td>2</td>
                            <td>2,000 each</td>
                          </tr>
                          <tr>
                            <td>6-10</td>
                            <td>5</td>
                            <td>1,500 each</td>
                          </tr>
                          <tr>
                            <td>11-20</td>
                            <td>10</td>
                            <td>1,000 each</td>
                          </tr>
                          <tr>
                            <td>21-30</td>
                            <td>10</td>
                            <td>500 each</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <li>
                    Players choose risk/reward:
                    <ul style={{ marginBottom: "5px" }}>
                      <li>More spins with smaller bet</li>
                      <li>Fewer spins with higher bet</li>
                    </ul>
                  </li>
                  <li>
                    <strong className="highlight">
                      All winnings are real money
                    </strong>{" "}
                    – no wagering required.
                  </li>
                  <li>
                    There will be{" "}
                    <strong className="highlight"> specific game</strong> where
                    winners can use their flexible freebets.
                  </li>
                  <li>
                    FGH reserves the right to modify, suspend, or terminate this
                    promotion at any time without prior notice.
                    <div className="table-wrapper">
                      <table
                        className="promotion-tnc-table"
                        style={{ minWidth: "100px" }}
                      >
                        <thead>
                          <tr>
                            <th>Flexible Freebets Schedule</th>
                            <th>Featured Game</th>
                            <th>Awarding Date & Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>November 1 12NN - November 8 11:59AM</td>
                            <td>More Magic Apple</td>
                            <td>November 8 14:00</td>
                          </tr>
                          <tr>
                            <td>November 10 12NN - November 29 11:59AM</td>
                            <td>3 Carts of Gold</td>
                            <td>November 29 14:00</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* <h2>Flexible Freebets Featured Game:</h2>
                    <div className="featuring-games">
                      <p>1st Week</p>
                      <p>2nd Week</p>
                      <p>3rd Week</p>
                      <p>4th Week</p>
                    </div> */}
                    <MasterGamesList
                      bngGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customFaChaiGames={[
                        {
                          provider: "bng",
                          gameName: "More Magic Apple",
                        },
                        { provider: "bng", gameName: "3 Carts of Gold" },
                      ]}
                      rank="off"
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>
                </ol>

                <div className="promotion-tnc-cta">
                  <a className="promotion-cta-btn" href="/slots/?provider=BNG">
                    Play Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
